export default {
  // for integration conflicts
  MuiAutocomplete: {
    endAdornment: {
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'flex',
    },
    option: {
      margin: 0,
    },
    input: {
      // IE clearable remove
      '&::-ms-clear': {
        display: 'none',
      },
    },
  },
  MuiFormControl: {
    root: {
      display: 'flex',
    },
  },
  MuiInputBase: {
    root: {
      display: 'flex',
    },
  },
  MuiButtonBase: {
    root: {
      display: 'flex',
    },
  },
  MuiTypography: {
    h1: {
      color: 'inherit',
    },
    h2: {
      color: 'inherit',
    },
    h3: {
      color: 'inherit',
    },
    h4: {
      color: 'inherit',
    },
    h5: {
      color: 'inherit',
    },
    h6: {
      color: 'inherit',
      fontFamily: "inherit"
    },
    body1: {
      padding: 0,
    },
    body2: {
      padding: 0,
    },
    caption: {
      padding: 0,
    },
  },
  MuiListItem: {
    container: {
      lineHeight: 'normal',
      marginBottom: 0,
    },
  },
  MuiLink: {
    root: {
      display: 'block',
      '&:hover, &:focus, &:visited': {
        color: 'inherit',
        textDecoration: 'underline',
      },
    },
  },
  MuiAlert: {
    // IE bug fix
    message: {
      flex: 1,
    },
  },
};
